import { render, staticRenderFns } from "./excellent.vue?vue&type=template&id=0a79b520&"
import script from "./excellent.vue?vue&type=script&lang=js&"
export * from "./excellent.vue?vue&type=script&lang=js&"
import style0 from "./excellent.vue?vue&type=style&index=0&id=0a79b520&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports